/**
 * Accounting Integration API Service
 *
 * Handles API calls for managing which accounting software
 * integrations an organisation has enabled.
 *
 * No Redux — the AccountingSoftwarePage manages its own async state.
 */

import axiosInstance from './axiosInstance';

/**
 * List all accounting integrations for the authenticated organisation.
 * Returns one entry per AccountingSoftware enum value (XERO, MYOB, QUICKBOOKS),
 * with enabled=false for any that haven't been toggled yet.
 *
 * @returns {Promise<AccountingIntegrationResponse[]>}
 */
export const listAccountingIntegrationsApi = async () => {
    const response = await axiosInstance.get('/accounting-integrations');
    return response.data;
};

/**
 * Enable or disable a specific accounting software integration.
 *
 * @param {{ software: string, enabled: boolean }} payload
 * @returns {Promise<AccountingIntegrationResponse>}
 */
export const toggleAccountingIntegrationApi = async (payload) => {
    const response = await axiosInstance.put('/accounting-integrations/toggle', payload);
    return response.data;
};

const accountingIntegrationApi = {
    listAccountingIntegrationsApi,
    toggleAccountingIntegrationApi,
};

export default accountingIntegrationApi;